/**
* Custom Select
*/
class customSelect extends HTMLElement{
  constructor() {
    super();
    this.selectContainer = this.querySelector('.custom--select');
    this.select = this.querySelector('ul');
    this.initOption = this.querySelector('.default');
    this.options = this.select.querySelectorAll('li');

    this.options.forEach(option => option.addEventListener('click', this.toggleOptions.bind(this)));
    this.initOption.addEventListener('click', this.manageVisibility.bind(this));

    this.addEventListener('click', (event) => {
      event.stopPropagation();
    });
    document.body.addEventListener('click', ()=> {
      Utility.toggleElement(this.selectContainer, 'close')
    });
  }

  /**
   * Toggle custom select option
   * @param event 
   */
  toggleOptions(event){
    let _this = event.currentTarget;
    this.options.forEach(option => option.classList.remove('selected'));
    _this.classList.add('selected');
    this.initOption.querySelector('.option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
    Utility.toggleElement(this.selectContainer, 'close');
  }

  /**
   * Hide/Show of custom select option
   * @param event 
   */
  manageVisibility(event){
    let isOpen = this.selectContainer.classList.contains('open');
    isOpen ? Utility.toggleElement(this.selectContainer, 'close') : Utility.toggleElement(this.selectContainer, 'open');
  }
}
customElements.define('custom-select', customSelect);

/**
* Tab HTML
*/
class customTabs extends HTMLElement {
    constructor() {
      super();
  
      this.tabLinks = this.querySelectorAll('.tablink');
      this.tabContainers = this.querySelectorAll('.tabcontent');
  
      this.tabLinks.forEach( link => link.addEventListener('click', this.toggleTabs.bind(this)));
    }
  
    /**
     * Escape Key Press to close drawer when focus is within the container
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code && event.code.toUpperCase() !== 'ESCAPE') return;
    }
  
    /**
     * Toggle Tabs on link click
     *
     * @param {event} Event instance
     */
    toggleTabs(event){
      event.preventDefault();
      event.stopPropagation();
      const currentTab = event.currentTarget;
      const tabLink = currentTab.querySelector('[data-toggle="tab"]');
      const tabContainer = document.querySelector(tabLink.dataset.tabcontent);
  
      this.openTab(currentTab, tabContainer)
    }
  
    /**
     * Open Tab Container
     *
     * @param {Node} currentTab Tab Container Open link
     * @param {Node} tabContainer Tab Container to open
     */
    openTab(currentTab, tabContainer) {
      this.tabContainers.forEach(container => {
        container.classList.remove('open');
        const linkEle = document.querySelector('.tablink a[data-toggle="tab"][data-tabcontent="#'+container.id+'"]');
        if(linkEle){
          linkEle.setAttribute('aria-expanded', false);
          if(linkEle.closest('.tablink')){ linkEle.closest('.tablink').classList.remove('open');}
        }
      });
      currentTab.classList.add('open');
      currentTab.querySelector('[data-toggle="tab"]').setAttribute('aria-expanded', true);
      tabContainer.classList.add('open');
    }
}
customElements.define("custom-tabs", customTabs);

/**
  * collaspsible Panel
  *
  * @param {element} element - Collapsible panel element
*/
class collapsiblePanel {
  constructor(element) {
    this.element = element;
    this.toggleBtn = this.element.querySelector('.panel_toggle');
    if(this.toggleBtn) this.toggleBtn.addEventListener('click', this.toggleContent.bind(this));
  }

  /**
   * Toggle Row Content
   * @param {event} event 
  */
  toggleContent(event) {
    event.preventDefault();
    const isOpen = this.element.classList.contains('open');
    isOpen ? this.hideContent() : this.showContent();
  }

  /**
   * Show panel content
   */
   showContent() {
    this.toggleBtn.setAttribute('aria-expanded', true);
    Utility.toggleElement(this.element, 'open');
    Utility.trapFocus(this.element);

    if(this.element.dataset.behaviour == 'single'){
      let siblingBlocks = this.element.parentNode.querySelectorAll('[is="collapsiblePanel"].open');
      siblingBlocks.forEach(element => {
        if(element == this.element){ return; }
        element.querySelector('.panel_toggle').click();
      });
    }
  }

  /**
   * Hide panel content
   */
  hideContent() {
    this.toggleBtn.setAttribute('aria-expanded', false);
    Utility.toggleElement(this.element, 'close');
    Utility.removeTrapFocus(this.element);
  }

  static init() {
    const collapsibleElements = document.querySelectorAll('[is="collapsiblePanel"]');
    collapsibleElements.forEach((ele) => {
      new collapsiblePanel(ele);
    });
  }
}
collapsiblePanel.init();
  
class CustomEngraving extends HTMLElement {
  constructor() {
    super();

    // Query the input element
    this.input = this.querySelector("input[type='text']");
    
    this.font_size= this.querySelectorAll("[data-engraving-size] input[type='radio']")
    this.font_style= this.querySelectorAll("[data-engraving-font] input[type='radio']")
    this.cartElement = document.querySelector('cart-form');
    this.engraving_fees = this.input?.dataset?.fees;
    this.variantRadioOptions = this.querySelectorAll('[data-engraving-font], [data-engraving-size], fieldset');

    // Query the character count display element
    this.charCount = this.querySelector("[character-count]");

    // There are two overlays (mobile + desktop). Keep both in sync.
    this.textOverlays = this.querySelectorAll(".text-overlay");
    if (this.input) {
      this.input.addEventListener("input", this.inputChange.bind(this));
    }
   
    this.font_size.forEach((element) => {
      element.addEventListener("change", (event) => {
        this.manageFontSize(event);
      });
    });

    this.font_style.forEach((element) => {
      element.addEventListener("change", (event) => {
        this.manageFontStyle(event);
      });
    });

    this.variantRadioOptions.forEach((element) => {
      element.addEventListener("change", (event) => {
        const formLabel = event.currentTarget.querySelector(".bs-form-label");
        // Check if the label contains the radio button element and remove the 'text-danger' class
        if (formLabel?.classList.contains("text-danger")) {
          formLabel.classList.remove("text-danger");
        }
      });
    });
    
    
  }

  manageFontStyle(event) {
    const fontClassPrefix = "engraving_";

    // Add the new font class from the selected value
    const newFontClass = event.currentTarget.dataset.css_class;
    this.textOverlays?.forEach((overlay) => {
      // Remove existing font-related classes
      overlay.classList.forEach((cls) => {
        if (cls.startsWith(fontClassPrefix)) overlay.classList.remove(cls);
      });
      if (newFontClass) overlay.classList.add(newFontClass);
    });
  }

  manageFontSize(event) {

    const sizeClassPrefix = "fs-";

    // Add the new size class from the selected value
    const newSizeClass = event.currentTarget.value;
    this.textOverlays?.forEach((overlay) => {
      // Remove existing size-related classes
      overlay.classList.forEach((cls) => {
        if (cls.startsWith(sizeClassPrefix)) overlay.classList.remove(cls);
      });
      if (newSizeClass) overlay.classList.add(newSizeClass);
    });
  }


  inputChange() {
    // Get the current value of the input
    const text = this.input.value;

    // Update the character count display
    if (this.charCount) {
      this.charCount.textContent = `${text.length}/12`;
    }

    // Update the text overlay on the image
    this.textOverlays?.forEach((overlay) => {
      overlay.textContent = text;

      // Optional: slight layout tweak for max length
      // if (text.length >= 12) overlay.classList.add("mt-1");
      // else overlay.classList.remove("mt-1");

      // CircleType is loaded via an external script; guard in case it's missing
      if (typeof CircleType === 'function') {
        if(text.length > 10){
          new CircleType(overlay).radius(380);
        } else {
          new CircleType(overlay).radius(384);
        }
      }
    });

    let variantsHasRadioOptions = true;
    if (this.variantRadioOptions.length > 0) {
      
      this.variantRadioOptions.forEach(ele => {
        if (ele.querySelector('input:checked') == null) {
          ele.querySelector('.bs-form-label').classList.add('text-danger');
          variantsHasRadioOptions = false;
          return false
        } else {
          ele.querySelector('.bs-form-label').classList.remove('text-danger')
        }
      });
    }
  
  }
}

// Define the custom element
customElements.define("custom-engraving", CustomEngraving);






/**
* Accordion HTML
*/
class customAccordion extends HTMLElement {
  constructor() {
    super();
    this.accordionType = this.dataset.accordiontype;
    this.toggleBtns = this.querySelectorAll('.accordion__toggle');

    this.toggleBtns.forEach(button => button.addEventListener('click', this.toggleAccordionBlock.bind(this)));
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   *
   * @param {event} Event instance
   */
  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;
  }

  /**
   * Toggle Tabs on link click
   *
   * @param {event} Event instance
   */
   toggleAccordionBlock(event){
    event.preventDefault();
    const toggleBtn = event.currentTarget;
    const targetContainer = toggleBtn.parentNode;
    const isOpen = targetContainer.classList.contains('open');
    isOpen ? this.closeAccordionBlock(toggleBtn) : this.openAccordionBlock(toggleBtn);

    // scroll into view the accoridon on mobile
    if (window.innerWidth <= 991 && event.currentTarget?.dataset?.stickyAccordion) {
      var headerOffset = 45;
      var elementPosition = toggleBtn.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    
      window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
      });
    }
  }

  /**
   * Open Tab Container
   *
   * @param {Node} toggleBtn Accordion Block Open link
   */
   openAccordionBlock(toggleBtn) {
    let targetContainer = toggleBtn.parentNode;
    toggleBtn.setAttribute('aria-expanded', true);
    Utility.toggleElement(targetContainer, 'open');
    if(this.accordionType == 'single'){
      let siblingBlocks = targetContainer.parentNode.querySelectorAll('.accordion__container');
      siblingBlocks.forEach(element => {
        if(element == targetContainer){ return; }
        element.classList.remove('open');
        element.querySelector('.accordion__block').classList.remove('open');
        element.querySelector('.accordion__toggle').setAttribute('aria-expanded', false);
      });
    }
    Utility.trapFocus(targetContainer);
  }

  /**
   * Close Tab Container
   *
   * @param {Node} currentTab Tab Container link
   * @param {Node} tabContainer Tab Container to close
   */
   closeAccordionBlock(toggleFilterBtn) {
    const targetContainer = toggleFilterBtn.parentNode;
    toggleFilterBtn.setAttribute('aria-expanded', false);
    Utility.toggleElement(targetContainer, 'close');
    Utility.removeTrapFocus(targetContainer);
  }
}
customElements.define("custom-accordion", customAccordion);